export default "__VITE_ASSET__EIjaaTFl__"